export default "__VITE_ASSET__C$g9Fs_Q__"